<template>
  <div>
    <h1 class="text-h5 mb-4">My Cases</h1>
    <v-btn-toggle v-model="timeframe" dense mandatory color="primary">
      <v-btn small value="previous">Previous</v-btn>
      <v-btn small value="current">Current</v-btn>
      <v-btn small value="upcoming">Upcoming</v-btn>
    </v-btn-toggle>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <provider-cases
      :assignments="filteredAssignments"
      :loading="loading"
      :hideGrouping="true"
      :search="search || ''"
      :hideMandateDetails="true"
    ></provider-cases>
  </div>
</template>

<script>
import ProviderCases from "../Providers/provider-cases.vue";
export default {
  components: {
    ProviderCases,
  },
  data() {
    return {
      assignments: [],
      loading: false,
      timeframe: "current",
      search: "",
    };
  },
  computed: {
    filteredAssignments() {
      return this.assignments.filter(
        (item) => item.timeframe === this.timeframe
      );
    },
  },
  async mounted() {
    this.loading = true;
    let providerId =
      this.$store.state.sharedModule.providerId ||
      (await this.$store.dispatch("sharedModule/getProviderId"));
    if (Boolean(providerId)) {
      this.assignments = await this.$store.dispatch(
        "plansModule/getMyAssignments",
        providerId
      );
    } else {
      this.$store.commit(
        "uxModule/setSnackbarMsg",
        "Error Retrieving Your Cases"
      );
      this.$store.commit("uxModule/setShowSnackbar", true);
    }
    this.loading = false;
  },
};
</script>
